import React, { PureComponent } from "react";
import { IonButton, IonImg } from "@ionic/react";
import { CONTACT_DISPATCHER, DRIVER_NO_ROUTES_ERROR, ICON_PATH } from '../../utils/constants';
import { FormatText } from "../../pages/Menu/FormatTextComponent/formatText";
import "./MyLoadsError.scss"
import { logEvent } from "../../utils/Analytics";
import { EVENT, SCREEN } from "../../utils/constants.analytics";
import { IONICWrapper, isEntitled } from "../../utils/common";
interface ErrorProps {
    constantText: any;
    constantButton: any;
    redirectTo?: any;
    history:any;
}

export class MyLoadsError extends PureComponent<ErrorProps, any> {
    onClickHandler(){
        this.props.redirectTo && this.props.history &&this.props.history.push(this.props.redirectTo);
        logEvent(EVENT.UE_MYLOADS_NORESULTS_NEWSEARCH, {
            screen: SCREEN.MYLOADS,
        });
    }

    dispatcherIcon = IONICWrapper.details.getKeyValuePairs("dispatcher_icon");
    dispatcherMessage = IONICWrapper.details.getKeyValuePairs("dispatcher_message") || this.props.constantText;
    driverIcon = IONICWrapper.details.getKeyValuePairs("driver_icon");
    driverMessage = IONICWrapper.details.getKeyValuePairs("driver_message") || DRIVER_NO_ROUTES_ERROR;

    dispatcherIconName: string = "";
    driverIconName: string = "";
    
    render() {
        const isSearch = isEntitled('search', 'newSearch');
        this.dispatcherIconName =  ICON_PATH.no_search_icon; 
        this.driverIconName =  ICON_PATH.no_route_icon ;
        return (
            <div className="no-myloads-container" data-testid="loadsErrror">
                <div className="myloads-error-container">
                    <p className={"err-results-label"}>Results</p>
                </div>
                <div>
                    <img    
                        alt="logo"
                        className={"error-image-logo"}
                        src={isSearch ? this.dispatcherIconName : this.driverIconName}
                    />
                </div>
                <div className="myload-error-message" data-testid={"error-description"}>
                    <FormatText
                        
                        text={isSearch ? this.dispatcherMessage : this.driverMessage}
                        dataType={'richText'}
                    />
                </div>
                <div>
                    {(isSearch)?
                    <IonButton
                        data-testid={"search-redirect-btn"}
                        expand="full"
                        shape="round"
                        onClick={()=>this.onClickHandler()}
                        size="large"
                        type="submit"
                        class="error-navigate-btn"
                    >
                        <IonImg
                            src={ICON_PATH.search_error}
                            class="load-search"
                        />
                        {this.props.constantButton}
                    </IonButton>
                    : <p data-test={"contact-dispatcher"} className="contact-dispatcher">{CONTACT_DISPATCHER}</p>}
                </div>
            </div>
        );
    }
}
